import React, {Component} from 'react';
import {ListGroup} from 'reactstrap';
import Category from 'manuals/components/Category';

export default class CategoryList extends Component {
    render() {
        const {
            categoryList
        } = this.props;
        return (
            <ListGroup>
                {
                    categoryList.map(
                        (category, index) => (
                            <Category
                                key={`template_category_${category.id}`}
                                index={index + 1}
                                templateCategory={category}/>
                        )
                    )
                }
            </ListGroup>
        )
    }
}
